import React, { useState, useEffect,  } from "react";
import Box from "@mui/material/Box";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CDB", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export const AFL_EVENT_COLORS: { [id: string]: string } = {
  "Groundout": "#BDBDBD",
  "Single": "#008000",
  "Double": "#0000FF",
  "Home Run": "#f7eb11",
  "GIDP": "#BDBDBD",
  "Lineout": "#BDBDBD",
  "Flyout": "#BDBDBD",
  "Field Error": "#BDBDBD",
  sac_fly: "#BDBDBD",
  sac_bunt: "#BDBDBD",
  "Triple": "#f42f11",
  double_play: "#BDBDBD",
  fielders_choice_out: "#BDBDBD",
  fielders_choice: "#BDBDBD",
};

export default function AflPitcherGameLogs(props: any) {
  const [gameLog, setGameLog] = useState<any[]>([]);

  useEffect(() => {
    const path = "/afl/pitcher-game-log/" + props.id + (props.season ? "/" + props.season : "");
    fetch(props.prod ? "https://oriolebird.pythonanywhere.com" + path : path)
      .then((res) => res.json())
      .then((pData) => {
        //console.log("Game Log for ", props.id, pData.data);
        setGameLog(pData.data)
      });
  }, [props.id, props.prod, props.season]);


  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }


  // Get team colors for styling
  const teamColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][0]
    : teamColors["FA"][0];

  const textColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][1]
    : teamColors["FA"][1];

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "400px" : "100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor: teamColor,
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color: textColor,
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    Game Logs
                  </span>
                </Typography>
              </Grid>
            </div>

            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="game logs table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      Game
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      IP
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      BF
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      H
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      HR
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      BB
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      K
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      WHIP
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      BA
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      OBP
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      SLG
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      K/9
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      BB/9
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {gameLog.map((log, index) => (
                    <TableRow
                      key={`${log.game_pk}-${log.pitcher_name}`}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        backgroundColor: index % 2 === 0 ? '#fafafa' : 'white',
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        <a href={"https://baseballsavant.mlb.com/gamefeed?gamePk="+log.game_pk.toString()}>{log.game_pk}</a>
                      </TableCell>
                      <TableCell >
                        {log.ip ? (parseInt(log.ip)+((log.ip) % 1 / 3).toPrecision(1).toString().substring(1)) : '-'}
                      </TableCell>
                      <TableCell>{log.ab || 0}</TableCell>
                      <TableCell>{log.h || 0}</TableCell>
                      <TableCell>{log.hr || 0}</TableCell>
                      <TableCell>{log.bb || 0}</TableCell>
                      <TableCell>
                        {log.k || 0}
                      </TableCell>
                      

                      <TableCell >
                        {log.whip?.toFixed(2) || '0.00'}
                      </TableCell>
                      <TableCell>
                        {log.ba?.toFixed(3) || '.000'}
                      </TableCell>
                      <TableCell>
                        {log.obp?.toFixed(3) || '.000'}
                      </TableCell>
                      <TableCell>
                        {log.slg?.toFixed(3) || '.000'}
                      </TableCell>
                      <TableCell>
                        {log.k_per_9?.toFixed(1) || '0.0'}
                      </TableCell>
                      <TableCell>
                        {log.bb_per_9?.toFixed(1) || '0.0'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}